// extracted by mini-css-extract-plugin
export default {"content":"GettingStarted_content__xpSAl","command":"GettingStarted_command__49BGf","group":"GettingStarted_group__ciSlP"};